/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
var isWeb = typeof window !== 'undefined' && 'onload' in window;
var isNode = typeof process !== 'undefined' && !!(process.versions && process.versions.node);
var isWeex = typeof WXEnvironment !== 'undefined' && WXEnvironment.platform !== 'Web';
var isKraken = typeof __kraken__ !== 'undefined';
var isMiniApp = typeof my !== 'undefined' && my !== null && typeof my.alert !== 'undefined';
var isByteDanceMicroApp = typeof tt !== 'undefined' && tt !== null && typeof tt.showToast !== 'undefined';
var isBaiduSmartProgram = typeof swan !== 'undefined' && swan !== null && typeof swan.showToast !== 'undefined';
var isKuaiShouMiniProgram = typeof ks !== 'undefined' && ks !== null && typeof ks.showToast !== 'undefined'; // In wechat mini program, wx.login is a function
// In wechat mini propgram webview, there is no wx.login, but exist wx.miniProgram
// In bytedance maicro app, there is wx variable.
// In kuaishou mini program, there is wx variable.

var isWeChatMiniProgram = !isByteDanceMicroApp && typeof wx !== 'undefined' && wx !== null && (typeof wx.request !== 'undefined' || typeof wx.miniProgram !== 'undefined');
var isQuickApp = typeof global !== 'undefined' && global !== null && typeof global.callNative !== 'undefined' && !isWeex;
var isPHA = isWeb && typeof pha === 'object';
var isFRM = isMiniApp && isWeb && my.isFRM; // WindVane.call is a function while page importing windvane.js

var ua = typeof navigator === 'object' ? navigator.userAgent || navigator.swuserAgent : '';
var isWindVane = /.+AliApp\((\w+)\/((?:\d+\.)+\d+)\).* .*(WindVane)(?:\/((?:\d+\.)+\d+))?.*/.test(ua) && isWeb && typeof WindVane !== 'undefined' && typeof WindVane.call !== 'undefined';
var index = {
  isWeb: isWeb,
  isNode: isNode,
  isWeex: isWeex,
  isKraken: isKraken,
  isMiniApp: isMiniApp,
  isByteDanceMicroApp: isByteDanceMicroApp,
  isBaiduSmartProgram: isBaiduSmartProgram,
  isKuaiShouMiniProgram: isKuaiShouMiniProgram,
  isWeChatMiniProgram: isWeChatMiniProgram,
  isQuickApp: isQuickApp,
  isPHA: isPHA,
  isWindVane: isWindVane,
  isFRM: isFRM
};

var es = /*#__PURE__*/Object.freeze({
  __proto__: null,
  isWeb: isWeb,
  isNode: isNode,
  isWeex: isWeex,
  isKraken: isKraken,
  isMiniApp: isMiniApp,
  isByteDanceMicroApp: isByteDanceMicroApp,
  isBaiduSmartProgram: isBaiduSmartProgram,
  isKuaiShouMiniProgram: isKuaiShouMiniProgram,
  isWeChatMiniProgram: isWeChatMiniProgram,
  isQuickApp: isQuickApp,
  isPHA: isPHA,
  isFRM: isFRM,
  isWindVane: isWindVane,
  'default': index
});

export { isKuaiShouMiniProgram as a, isWeChatMiniProgram as b, isByteDanceMicroApp as c, isMiniApp as d, isBaiduSmartProgram as e, es as f, isWeb as i };
